import { render, staticRenderFns } from "./vehicle-list.vue?vue&type=template&id=f15f6f54"
import script from "./vehicle-list.vue?vue&type=script&lang=js"
export * from "./vehicle-list.vue?vue&type=script&lang=js"
import style0 from "./vehicle-list.vue?vue&type=style&index=0&id=f15f6f54&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports